import React from 'react';
import { Tab, Form, TextArea } from 'semantic-ui-react';
import { generate } from 'shortid';


const Pane = (props) => {
  const { data, lang } = props;

  return (
    <Tab.Pane>
      {
        data.map(({ name, value, desc }) => {
          const nameWithLang = name + '.' + lang;
          const text = value[lang];
          
          return (
            <Form.Field
              key={ generate()}
              control={TextArea}
              label={desc}
              name={nameWithLang}
              placeholder=''
              value={text}
              onChange={props.onChange}
            />
          );
        })
      }
    </Tab.Pane>
  );
};

export default Pane;



// WEBPACK FOOTER //
// ./src/private/common/components/I18nTabs/Pane.js